export default __webpack_public_path__ + "static/media/07.ff2f47f6.png";